"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationPriority;
(function (ValidationPriority) {
    ValidationPriority[ValidationPriority["MAJOR"] = 0] = "MAJOR";
    ValidationPriority[ValidationPriority["MINOR"] = 1] = "MINOR";
})(ValidationPriority = exports.ValidationPriority || (exports.ValidationPriority = {}));
var ValidationPriorityHelper = /** @class */ (function () {
    function ValidationPriorityHelper() {
        this.priorities = new Map();
        this.priorities.set("MAJOR", ValidationPriority.MAJOR);
        this.priorities.set("MINOR", ValidationPriority.MINOR);
    }
    ValidationPriorityHelper.prototype.getPriority = function (priority) {
        return this.priorities.get(priority);
    };
    return ValidationPriorityHelper;
}());
exports.ValidationPriorityHelper = ValidationPriorityHelper;
//# sourceMappingURL=validation-priority.js.map